// frontend/src/utils/useJWTSession.js

/**
 * Guarda el token JWT en sessionStorage
 * 
 * @param {string} token - JWT devuelto por el backend
 */
export const setJWTSession = (token) => {
  sessionStorage.setItem("jwt_token", token);
};

/**
 * Obtiene el token JWT almacenado en sessionStorage
 * 
 * @returns {string|null} El token JWT o null si no existe
 */
export const getJWTSession = () => {
  return sessionStorage.getItem("jwt_token");
};

/**
 * Elimina el token JWT de sessionStorage
 */
export const clearJWTSession = () => {
  sessionStorage.removeItem("jwt_token");
};
